import { path } from "../../config";
import { store } from "../../redux/store";
import fetchServer from "../fetchServer";


export default async function getFlightOfferPrice(obj,userId,userType) {
  var result = {return: 0,msg: 'Error',data: {}}

  let token = store.getState().user.userData.accessToken;
  
  console.log("on price req : ",obj);

  let headers = {Authorization: `Bearer ${token}`}

  if(userId)
    headers['user-id'] = userId;
  if(userType)
    headers['user-type'] = userType?.toUpperCase();

  await fetchServer({method: "POST",url: path.api+`/flights/price/`,
    data: obj,
    headers
  })
  .then((res) => {
    console.log(" => ",{...res})
    if(res) {
      if(res?.data?.success) {
        result = {return: 1,msg: "Successfull",data: res.data.data};
      } else if(res?.error) result['msg'] = res?.error?.message;
    } 
  })
  .catch((err) => {
    console.log("Network Error: ",err);
    
    // result = {return: 1,msg: 'Successfull',data:[]}
  })

  return result;
}